export const percentReduce = (data) => {
  let dataValue = [];
  data.map((objecData) => {
    Object.keys(objecData).forEach((key) => {
      if (typeof objecData[key] === 'number') {
        dataValue.push(objecData[key]);
      }
    });
  });

  return dataValue.reduce((acc, curr) => acc + curr, 0);
};
